import Reveal from "./Reveal";

const values = [
  "Ciência",
  "Humanização",
  "Ética",
  "Acolhimento",
  "Especialização",
  "Segurança",
  "Tecnologia",
  "Respeito à individualidade",
];

export default function Purpose() {
  return (
    <section className="bg-accent-100/50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
                Propósito
              </p>
              <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.12] tracking-tight text-foreground-950 md:text-5xl">
                Ciência para tratar.
                <br />
                Cuidado para acolher.
              </h2>
              <p className="mt-6 text-base leading-relaxed text-foreground-600 md:text-lg">
                Contribuir para a recuperação da saúde, do conforto e da
                qualidade de vida através de assistência especializada,
                conhecimento científico, recursos terapêuticos, escuta e
                cuidado humano.
              </p>
            </Reveal>

            <Reveal delay={100}>
              <div className="mt-8 rounded-lg border border-primary-600/20 bg-background-50 p-6">
                <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
                  Missão
                </h3>
                <p className="mt-3 font-heading text-xl leading-relaxed text-foreground-800">
                  Promover cuidado especializado, contribuir para a cicatrização
                  e o alívio da dor e favorecer qualidade de vida através de uma
                  assistência baseada em ciência, tecnologia e humanização.
                </p>
              </div>
            </Reveal>
          </div>

          <div>
            <Reveal delay={80}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-foreground-500">
                Valores
              </h3>
              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {values.map((value, i) => (
                  <Reveal key={value} delay={i * 40}>
                    <li className="flex items-center gap-3 border-t border-foreground-200/60 pt-4">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i
                          className="ri-leaf-line text-sm"
                          aria-hidden="true"
                        ></i>
                      </span>
                      <span className="text-base font-medium text-foreground-800">
                        {value}
                      </span>
                    </li>
                  </Reveal>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}